import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { API_URL } from "..";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

// Vehicle-related data functions (copied from AddJobs)
function getYearsArray() {
  const currentYear = new Date().getFullYear();
  const startYear = 1927;
  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(`${year}`);
  }
  return years;
}

function getVehicleMakes() {
  return [
    "Acura", "Alfa Romeo", "AM General", "Aston Martin", "Audi", "Bentley", "BMW",
    "Buick", "Cadillac", "Chevrolet", "Chrysler", "Dodge", "Ferrari", "Fiat",
    "Ford", "Genesis", "GMC", "Honda", "Hummer", "Hyundai", "Infiniti", "Jaguar",
    "Jeep", "Kia", "Lamborghini", "Land Rover", "Lexus", "Lincoln", "Lotus",
    "Lucid", "Maserati", "Mazda", "McLaren", "Mercedes-Benz", "Mini", "Mitsubishi",
    "Nissan", "Porsche", "Ram", "Rivian", "Rolls-Royce", "Subaru", "Tesla",
    "Toyota", "Volkswagen", "Volvo"
  ];
}

function getVehicleModelsByMake(vehicleMake) {
  const makeModelMapping = {
    Acura: ["ILX", "MDX", "NSX", "RDX", "TLX"],
    "Alfa Romeo": ["Giulia", "Stelvio", "Tonale"],
    Audi: ["A3", "A4", "A5", "A6", "Q3", "Q5", "Q7", "e-tron"],
    BMW: ["3 Series", "5 Series", "X3", "X5", "i4", "iX"],
    Chevrolet: ["Camaro", "Corvette", "Silverado", "Equinox", "Tahoe"],
    Chrysler: ["Pacifica", "300"],
    Dodge: ["Challenger", "Charger", "Durango"],
    Ford: ["Mustang", "F-150", "Bronco", "Explorer", "Mach-E"],
    GMC: ["Sierra", "Yukon", "Terrain", "Hummer EV"],
    Honda: ["Civic", "Accord", "CR-V", "Pilot"],
    Hyundai: ["Elantra", "Sonata", "Tucson", "Santa Fe", "Ioniq 5"],
    Jeep: ["Wrangler", "Grand Cherokee", "Cherokee", "Gladiator"],
    Kia: ["Forte", "Optima", "Sportage", "Telluride", "EV6"],
    Lexus: ["RX", "NX", "ES", "IS"],
    "Mercedes-Benz": ["C-Class", "E-Class", "GLC", "GLE", "EQE"],
    Nissan: ["Altima", "Sentra", "Rogue", "Pathfinder", "Leaf"],
    Porsche: ["911", "Cayenne", "Macan", "Taycan"],
    Ram: ["1500", "2500", "3500"],
    Subaru: ["Outback", "Forester", "Crosstrek"],
    Tesla: ["Model 3", "Model S", "Model X", "Model Y", "Cybertruck"],
    Toyota: ["Camry", "Corolla", "RAV4", "Highlander", "Tacoma"],
    Volkswagen: ["Jetta", "Passat", "Tiguan", "Atlas", "ID.4"],
  };
  return makeModelMapping[vehicleMake] || [];
}

function getCarColorsArray() {
  return [
    "White", "Black", "Gray", "Silver", "Blue", "Red", "Green", "Brown", "Orange",
    "Beige", "Purple", "Gold", "Yellow", "Pearl White", "Matte Black", "Metallic Gray",
    "Silver Metallic", "Navy Blue", "Bright Red", "Forest Green", "Chocolate Brown",
    "Burnt Orange", "Tan", "Deep Purple", "Champagne Gold", "Lemon Yellow"
  ];
}

const InvoiceEditLayer = ({ data, invoiceID }) => {
  const [currentUser, setCurrentUser] = useState({});
  const [invoiceData, setInvoiceData] = useState({
    invoiceNumber: data?.invoice_number || "",
    issuedDate: data?.issue_date || "",
    dueDate: data?.due_date || "",
    customerName: data?.customer_name || "",
    customerAddress: data?.address || "",
    customerPhone: data?.phone || "",

  });
  const [message, setMessage] = useState({
    status: false,
    reason: "",
    desc: "",
  });
  const [showDiscount, setShowDiscount] = useState(false);
  const [showTax, setShowTax] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState(data?.items || []);
  const [discount, setDiscount] = useState(parseFloat(data?.discount) || 0);
  const [taxAmount, setTaxAmount] = useState(parseFloat(data?.tax) || 0);
  console.log(data)
  const [newItem, setNewItem] = useState({
    item_name: "",
    quantity: "",
    unit_price: "",
  });

  // Vehicle and towing reason states
  const vehicleOptions = ["Light", "Medium", "Tractor", "Equipment", "Container", "Material", "Other"];
  const VehicleYear = getYearsArray();
  const vehicleMake = getVehicleMakes();
  const [vehicleModelArray, setVehicleModelArray] = useState(getVehicleModelsByMake(data?.job?.vehicle_make));
  const carColors = getCarColorsArray();
  const [selectedVehicleType, setSelectedVehicleType] = useState([data?.job?.vehicle_type || ""]);
  const [selectedYear, setSelectedYear] = useState([data?.job?.vehicle_year || ""]);
  const [selectedMake, setSelectedMake] = useState([data?.job?.vehicle_make || ""]);
  const [selectedModel, setSelectedModel] = useState([data?.job?.vehicle_model || ""]);
  const [selectedCarColor, setSelectedCarColor] = useState([data?.job?.vehicle_color || ""]);
  const [licensePlate, setLicensePlate] = useState(data?.job?.license_plate || "");
  const [vin, setVin] = useState(data?.job?.vin || "");
  const [towingReason, setTowingReason] = useState(data?.job?.job_type || "");

  const getCurrentUser = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setCurrentUser(user);
  };

  useEffect(() => {
    getCurrentUser();
  }, []);

  const handleInputChange = (field, value) => {
    setNewItem({ ...newItem, [field]: value });
  };

  const addItem = () => {
    if (newItem.item_name && newItem.quantity && newItem.unit_price) {
      setInvoiceItems([
        ...invoiceItems,
        {
          ...newItem,
          price: (parseFloat(newItem.quantity) * parseFloat(newItem.unit_price)).toFixed(2),
        },
      ]);
      setNewItem({ item_name: "", quantity: "", unit_price: "" });
    }
  };

  const removeItem = (id) => {
    setInvoiceItems(invoiceItems.filter((item) => item.id !== id));
  };

  const startEditing = (field) => {
    setEditingField(field);
  };

  const handleChange = (field, value) => {
    setInvoiceData({ ...invoiceData, [field]: value });
  };

  const stopEditing = () => {
    setEditingField(null);
  };

  const handleDiscountChange = (value) => {
    setDiscount(parseFloat(value) || 0);
  };

  const handleTaxChange = (value) => {
    setTaxAmount(parseFloat(value) || 0);
  };

  const calculateSubtotal = () =>
    invoiceItems.reduce((acc, item) => acc + parseFloat(item.price || 0), 0);

  const calculateDiscountedTotal = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = (subtotal * discount) / 100;
    return subtotal - discountAmount;
  };

  const calculateTax = (total) => (total * taxAmount) / 100;

  const calculateTotal = () => {
    const discountedTotal = calculateDiscountedTotal();
    return discountedTotal + calculateTax(discountedTotal);
  };

  const handleInvoiceSubmit = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };
    const bodyContent = JSON.stringify({
      invoice_number: invoiceData.invoiceNumber,
      customer_name: invoiceData.customerName,
      phone: invoiceData.customerPhone,
      address: invoiceData.customerAddress,
      issue_date: invoiceData.issuedDate,
      due_date: invoiceData.dueDate,
      amount: calculateTotal(),
      discount: discount,
      tax: taxAmount,
      affiliate_id: user.id,
      items: invoiceItems,
      vehicle_type: selectedVehicleType[0] || "",
      vehicle_year: selectedYear[0] || "",
      vehicle_make: selectedMake[0] || "",
      vehicle_model: selectedModel[0] || "",
      vehicle_color: selectedCarColor[0] || "",
      license_plate: licensePlate,
      vin: vin,
      towing_reason: towingReason,
    });


    const response = await fetch(`${API_URL}/api/invoice/update/${user.id}/${invoiceID}`, {
      method: "PUT",
      headers: headersList,
      body: bodyContent,
    });
    const result = await response.json();
    if (response.status === 200) {
      setMessage({
        status: true,
        reason: "success",
        desc: "Invoice updated successfully",
      });
    } else {
      setMessage({
        status: true,
        reason: "error",
        desc: "Failed to update invoice",
      });
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
          <button
            onClick={handleInvoiceSubmit}
            className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center gap-1"
          >
            <Icon icon="simple-line-icons:check" className="text-xl" />
            Save
          </button>
        </div>
      </div>
      <div className="card-body py-40">
        <div className="row justify-content-center" id="invoice">
          {message.status && (
            <div
              className={
                message.reason === "error"
                  ? "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                  : "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
              }
              role="alert"
            >
              {message.desc}
              <button
                type="button"
                onClick={() => setMessage({ ...message, status: false })}
                className="remove-button text-secondary-600 text-xxl line-height-1"
              >
                <Icon icon="iconamoon:sign-times-light" className="icon" />
              </button>
            </div>
          )}
          
          <div className="col-lg-8">
            <div className="shadow-4 border radius-8">
              <div className="p-20 border-bottom">
                <div className="row justify-content-between g-3">
                  <div className="col-sm-4">
                    <h3 className="text-xl">
                      Invoice #{" "}
                      {editingField === "invoiceNumber" ? (
                        <input
                          type="text"
                          value={invoiceData.invoiceNumber}
                          onChange={(e) => handleChange("invoiceNumber", e.target.value)}
                          onBlur={stopEditing}
                          className="editable-input"
                        />
                      ) : (
                        <span
                          onClick={() => startEditing("invoiceNumber")}
                          className="editable text-decoration-underline"
                        >
                          {invoiceData.invoiceNumber}
                        </span>
                      )}
                    </h3>
                    <p className="mb-1 text-sm">
                      Date Issued:{" "}
                      {editingField === "issuedDate" ? (
                        <input
                          type="date"
                          value={invoiceData.issuedDate}
                          onChange={(e) => handleChange("issuedDate", e.target.value)}
                          onBlur={stopEditing}
                          className="editable-input"
                        />
                      ) : (
                        <span
                          onClick={() => startEditing("issuedDate")}
                          className="editable text-decoration-underline"
                        >
                          {invoiceData.issuedDate}
                        </span>
                      )}
                      <span className="text-success-main">
                        <Icon icon="mage:edit" onClick={() => startEditing("issuedDate")} />
                      </span>
                    </p>
                    <p className="mb-0 text-sm">
                      Date Due:{" "}
                      {editingField === "dueDate" ? (
                        <input
                          type="date"
                          value={invoiceData.dueDate}
                          onChange={(e) => handleChange("dueDate", e.target.value)}
                          onBlur={stopEditing}
                          className="editable-input"
                        />
                      ) : (
                        <span
                          onClick={() => startEditing("dueDate")}
                          className="editable text-decoration-underline"
                        >
                          {invoiceData.dueDate}
                        </span>
                      )}
                      <span className="text-success-main">
                        <Icon icon="mage:edit" onClick={() => startEditing("dueDate")} />
                      </span>
                    </p>
                  </div>
                  <div className="col-sm-4">
                    {currentUser.business_logo ? (
                      <img style={{ width: 200 }} src={API_URL + currentUser.business_logo} alt="Business Logo" />
                    ) : (
                      <h6>{currentUser.business_name}</h6>
                    )}
                    <p className="mb-1 text-sm">{currentUser.address}</p>
                    <p className="mb-0 text-sm">{currentUser.email}</p>
                    <p className="mb-0 text-sm">{currentUser.phone}</p>
                  </div>
                </div>
              </div>
              <div className="py-28 px-20">
                <div className="d-flex flex-wrap justify-content-between align-items-end gap-3">
                  <div>
                    <h6 className="text-md">Issue For:</h6>
                    <table className="text-sm text-secondary-light">
                      <tbody>
                        <tr>
                          <td>Name</td>
                          <td className="ps-8">
                            :{" "}
                            {editingField === "customerName" ? (
                              <input
                                type="text"
                                value={invoiceData.customerName}
                                onChange={(e) => handleChange("customerName", e.target.value)}
                                onBlur={stopEditing}
                                className="editable-input"
                              />
                            ) : (
                              <span
                                onClick={() => startEditing("customerName")}
                                className="editable text-decoration-underline"
                              >
                                {invoiceData.customerName}
                              </span>
                            )}
                            <span className="text-success-main">
                              <Icon icon="mage:edit" onClick={() => startEditing("customerName")} />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>Address</td>
                          <td className="ps-8">
                            :{" "}
                            {editingField === "customerAddress" ? (
                              <input
                                type="text"
                                value={invoiceData.customerAddress}
                                onChange={(e) => handleChange("customerAddress", e.target.value)}
                                onBlur={stopEditing}
                                className="editable-input"
                              />
                            ) : (
                              <span
                                onClick={() => startEditing("customerAddress")}
                                className="editable text-decoration-underline"
                              >
                                {invoiceData.customerAddress}
                              </span>
                            )}
                            <span className="text-success-main">
                              <Icon icon="mage:edit" onClick={() => startEditing("customerAddress")} />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>Phone number</td>
                          <td className="ps-8">
                            :{" "}
                            {editingField === "customerPhone" ? (
                              <input
                                type="text"
                                value={invoiceData.customerPhone}
                                onChange={(e) => handleChange("customerPhone", e.target.value)}
                                onBlur={stopEditing}
                                className="editable-input"
                              />
                            ) : (
                              <span
                                onClick={() => startEditing("customerPhone")}
                                className="editable text-decoration-underline"
                              >
                                {invoiceData.customerPhone}
                              </span>
                            )}
                            <span className="text-success-main">
                              <Icon icon="mage:edit" onClick={() => startEditing("customerPhone")} />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Vehicle Information Section */}

                <div className="mt-24">
                  <h6>Vehicle Information</h6>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="text-sm text-secondary-light mb-2">License Plate</label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        value={licensePlate}
                        onChange={(e) => setLicensePlate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="text-sm text-secondary-light mb-2">VIN</label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        value={vin}
                        onChange={(e) => setVin(e.target.value)}
                      />
                    </div>
                    <div style={{ paddingTop: 10 }} />
                    <div className="col-md-4">
                      <label className="text-sm text-secondary-light mb-2">Vehicle Type</label>
                      <Typeahead
                        labelKey="type"
                        id="vehicle_Type"
                        options={vehicleOptions}
                        onChange={(selected) => setSelectedVehicleType(selected)}
                        selected={selectedVehicleType}
                        placeholder=""
                        inputProps={{ className: "form-control radius-8" }}
                        className="radius-8"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-sm text-secondary-light mb-2">Vehicle Year</label>
                      <Typeahead
                        labelKey="name"
                        id="vehicle_Year"
                        options={VehicleYear}
                        onChange={(selected) => setSelectedYear(selected)}
                        selected={selectedYear}
                        placeholder=""
                        inputProps={{ className: "form-control radius-8" }}
                        className="radius-8"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-sm text-secondary-light mb-2">Vehicle Make</label>
                      <Typeahead
                        labelKey="name"
                        id="vehicle_Make"
                        options={vehicleMake}
                        onChange={(selected) => {
                          setSelectedMake(selected);
                          setVehicleModelArray(getVehicleModelsByMake(selected[0]));
                        }}
                        selected={selectedMake}
                        placeholder=""
                        inputProps={{ className: "form-control radius-8" }}
                        className="radius-8"
                      />
                    </div>
                    <div style={{ paddingTop: 10 }} />
                    <div className="col-md-4">
                      <label className="text-sm text-secondary-light mb-2">Vehicle Model</label>
                      <Typeahead
                        labelKey="name"
                        id="vehicle_Model"
                        options={vehicleModelArray}
                        onChange={(selected) => setSelectedModel(selected)}
                        selected={selectedModel}
                        placeholder=""
                        inputProps={{ className: "form-control radius-8" }}
                        className="radius-8"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-sm text-secondary-light mb-2">Vehicle Color</label>
                      <Typeahead
                        labelKey="type"
                        id="vehicle_Color"
                        options={carColors}
                        onChange={(selected) => setSelectedCarColor(selected)}
                        selected={selectedCarColor}
                        placeholder=""
                        inputProps={{ className: "form-control radius-8" }}
                        className="radius-8"
                      />
                    </div>
                  </div>
                </div>

                {/* Towing Reason Section */}
                <div className="mt-24">
                  <h6>Towing Reason</h6>
                  <div className="d-flex align-items-center flex-wrap gap-28">
                    <div className="form-check checked-primary d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="towingReason"
                        id="roadsideAssistance"
                        onChange={(e) => setTowingReason(e.target.value)}
                        value="Roadside Assistance"
                        checked={towingReason === "Roadside Assistance"}
                      />
                      <label
                        className="form-check-label line-height-1 fw-medium text-secondary-light"
                        htmlFor="roadsideAssistance"
                      >
                        Roadside Assistance
                      </label>
                    </div>
                    <div className="form-check checked-secondary d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="towingReason"
                        id="towingService"
                        onChange={(e) => setTowingReason(e.target.value)}
                        value="Towing Service"
                        checked={towingReason === "Towing Service"}
                      />
                      <label
                        className="form-check-label line-height-1 fw-medium text-secondary-light"
                        htmlFor="towingService"
                      >
                        Towing Service
                      </label>
                    </div>
                  </div>
                </div>

                {/* Invoice Items Table */}
                <div className="mt-24">
                  <div className="table-responsive scroll-sm">
                    <table className="table bordered-table text-sm" id="invoice-table">
                      <thead>
                        <tr>
                          <th scope="col" className="text-sm">SL.</th>
                          <th scope="col" className="text-sm">Items</th>
                          <th scope="col" className="text-sm">Qty</th>
                          <th scope="col" className="text-sm">Unit Price</th>
                          <th scope="col" className="text-sm">Price</th>
                          <th scope="col" className="text-center text-sm">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoiceItems.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.item_name}</td>
                            <td>{item.quantity}</td>
                            <td>${item.unit_price}</td>
                            <td>${item.price}</td>
                            <td className="text-center">
                              <button
                                type="button"
                                className="remove-row btn btn-sm btn-danger"
                                onClick={() => removeItem(item.id)}
                              >
                                <Icon icon="ic:twotone-close" className="text-xl" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex flex-wrap align-items-center gap-2 mt-4">
                    <input
                      type="text"
                      className="form-control text-sm"
                      placeholder="Item Name"
                      value={newItem.item_name}
                      onChange={(e) => handleInputChange("item_name", e.target.value)}
                    />
                    <input
                      type="number"
                      className="form-control text-sm"
                      placeholder="Quantity"
                      value={newItem.quantity}
                      onChange={(e) => handleInputChange("quantity", e.target.value)}
                    />
                    <input
                      type="number"
                      className="form-control text-sm"
                      placeholder="Unit Price"
                      value={newItem.unit_price}
                      onChange={(e) => handleInputChange("unit_price", e.target.value)}
                    />
                    <button
                      type="button"
                      className="remove-row btn btn-sm btn-success"
                      onClick={addItem}
                    >
                      <Icon icon="simple-line-icons:plus" className="text-xl" />
                    </button>
                  </div>
                </div>

                {/* Total Calculation Section */}
                <div className="d-flex flex-wrap justify-content-between gap-3 mt-24">
                  <div></div>
                  <div>
                    <table className="text-sm">
                      <tbody>
                        <tr>
                          <td className="pe-64">Subtotal:</td>
                          <td className="pe-16">
                            <span className="text-primary-light fw-semibold">
                              ${calculateSubtotal().toFixed(2)}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="pe-64">
                            Discount in %: <Icon onClick={() => setShowDiscount(!showDiscount)} icon="mage:edit" />
                          </td>
                          {showDiscount ? (
                            <td>
                              <input
                                type="number"
                                className="form-control text-sm"
                                value={discount}
                                onChange={(e) => handleDiscountChange(e.target.value)}
                                placeholder="Enter discount"
                                min="0"
                                max="100"
                              />
                            </td>
                          ) : (
                            <td className="pe-16">
                              <span className="text-primary-light fw-semibold">
                                ${((calculateSubtotal() * discount) / 100).toFixed(2)}
                              </span>
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td className="pe-64 border-bottom pb-4">
                            Tax: <Icon onClick={() => setShowTax(!showTax)} icon="mage:edit" />
                          </td>
                          {showTax ? (
                            <td>
                              <input
                                type="number"
                                className="form-control text-sm"
                                value={taxAmount}
                                onChange={(e) => handleTaxChange(e.target.value)}
                                placeholder="Enter tax"
                                min="0"
                                max="100"
                              />
                            </td>
                          ) : (
                            <td className="pe-16 border-bottom pb-4">
                              <span className="text-primary-light fw-semibold">
                                ${calculateTax(calculateDiscountedTotal()).toFixed(2)}
                              </span>
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td className="pe-64 pt-4">
                            <span className="text-primary-light fw-semibold">Total:</span>
                          </td>
                          <td className="pe-16 pt-4">
                            <span className="text-primary-light fw-semibold">
                              ${calculateTotal().toFixed(2)}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceEditLayer;